import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useAuthStatus } from "./AuthStatusContext";

const AuthRoute: React.FC = () => {
  const { authStatus, groupStatus } = useAuthStatus();
  const auth = useAuth();
  const location = useLocation();
  const [isValidToken, setIsValidToken] = useState<boolean | null>(null);

  // Validate token expiration explicitly
  useEffect(() => {
    const validateToken = () => {
      try {
        const idToken = localStorage.getItem("id_token");
        const accessToken = localStorage.getItem("access_token");

        if (!idToken || !accessToken) {
          setIsValidToken(false);
          return false;
        }
        // tokens exist – assume valid; backend will enforce expiry
        setIsValidToken(true);
        return true;
      } catch (err) {
        console.error("Error validating tokens", err);
        setIsValidToken(false);
        return false;
      }
    };
    validateToken();
  }, [location.pathname]);

  // If unauthenticated trigger login immediately, unless we are already on the Cognito callback route
  if (authStatus === "unauth" && !auth.isLoading) {
    if (location.pathname.startsWith("/oauth2")) {
      // We are on the callback page waiting for tokens to process
      return <div>Completing sign in...</div>;
    }
    else {
      auth.signinRedirect();
      return <div>Redirecting to login...</div>;
    }
  }

  // Loading states
  if (auth.isLoading || isValidToken === null || authStatus === "loading" || groupStatus === "loading") {
    console.log("Verifying authentication...");
    console.log("auth.isLoading", auth.isLoading);
    console.log("isValidToken", isValidToken);
    console.log("authStatus", authStatus);
    console.log("groupStatus", groupStatus);
    return <div>Verifying authentication...</div>;
  }

  if (authStatus === "unauth") {
    // Trigger Cognito login
    auth.signinRedirect();
    return <div>Redirecting to login...</div>;
  }

  if (groupStatus === "unauthorized") {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
